import React, { useEffect, useState } from "react";
import {
  Button,
  Portal,
  createListCollection,
  Dialog,
  Select,
  Field,
  Box,
  Textarea,
  CloseButton,
  Input,
  Spinner,
  VStack,
  Group,
  SimpleGrid,
  Separator,
  Collapsible,
  Text,
  HStack,
} from "@chakra-ui/react";
import { useAppStore } from "../../../context/store";
import { LuClock, LuFocus, LuFolder, LuLayers, LuShieldQuestion, LuSquareCheck, LuText, LuTowerControl, LuUser } from "react-icons/lu";

import { floatingStyles, ReviewTitleOptions, showToast, truncateWords } from "../../../utilies/Utility";
import { serviceComment, serviceGetComment } from "../../../api/services/comment";
import { showBBoxOnMap } from "../../../utilies/ProjectUtility";
import Type from "../../../utilies/Types";
import { serviceGetTask } from "../../../api/services/task";
import { Tooltip } from "../../ui/tooltip";

const CommentReviewDialog = () => {
  // state
  const viewerRef = useAppStore((s) => s.viewerRef);
  const userData = useAppStore((s) => s.userData);
  const isShowCommentReviewDialog = useAppStore((s) => s.isShowCommentReviewDialog);
  const projects = useAppStore((s) => s.projects);
  const city = useAppStore((s) => s.city);
  const userType = useAppStore((s) => s.userType);
  const selectedProject = useAppStore((s) => s.selectedProject);
  const reviewTitle = useAppStore((s) => s.reviewTitle);

  // setter
  const setIsShowCommentReviewDialog = useAppStore.getState().setIsShowCommentReviewDialog;

  const [searchText, setSearchText] = useState("");
  const [isProgress, setIsProgress] = useState(false);
  const [queryTable, setQueryTable] = useState([]);
  const [filterTable, setFilterTable] = useState([]);

  const [cityOptions, setCityOptions] = useState(
    createListCollection({
      items: [],
    }),
  );
  const [projectOptions, setProjectOptions] = useState(
    createListCollection({
      items: [],
    }),
  );
  const [taskOptions, setTaskOptions] = useState(
    createListCollection({
      items: [],
    }),
  );

  const [layerOptions, setLayerOptions] = useState(
    createListCollection({
      items: [],
    }),
  );

  const [titleOptions, setTitleOptions] = useState(
    createListCollection({
      items: [],
    }),
  );
  useEffect(() => {
    if (reviewTitle.length > 0) {
      try {
        const source = Array.isArray(reviewTitle) ? reviewTitle : [];

        const groupedByCategory = source.reduce((acc, item) => {
          const cat = item?.category ?? "uncategorized"; // fallback in case of missing category
          if (!acc[cat]) acc[cat] = [];
          acc[cat].push(item);
          return acc;
        }, {});

        let items = Object.entries(groupedByCategory).map(([category, arr]) => {
          const options = arr
            .slice()
            .sort((a, b) => a.type.localeCompare(b.type))
            .map((it) => ({
              label: it.type, // e.g., "Feature Not Sliced"
              value: it.type_short, // e.g., "feature_not_sliced"
            }));

          return { category, options };
        });

        items = items.sort((a, b) => a.category.localeCompare(b.category));

        setTitleOptions(
          createListCollection({
            items,
          }),
        );
      } catch (e) {}
    }
  }, [reviewTitle]);

  const [formReviewId, setFormReviewId] = useState("");
  const [formCity, setFormCity] = useState("");
  const [formProject, setFormProject] = useState("");
  const [formTitle, setFormTitle] = useState("");
  const [formLayer, setFormLayer] = useState("");
  const [formUser, setFormUser] = useState("");
  const [formContext, setFormContext] = useState("");
  const [formTask, setFormTask] = useState("");

  useEffect(() => {
    if (selectedProject) {
      setFormProject(selectedProject?.id);
      for (const key in projects) {
        if (projects[key].id == selectedProject?.id) {
          let temp = [{ label: "No Layer", value: "" }];
          for (const key2 in projects[key].layers) {
            temp.push({ label: projects[key].layers[key2].layer_name, value: projects[key].layers[key2].id });
          }
          setLayerOptions(
            createListCollection({
              items: temp,
            }),
          );
          break;
        }
      }

      updateTaskOptions(selectedProject?.id);
    }
  }, [selectedProject]);

  const loadComments = () => {
    const formData = new FormData();

    let temp = {};
    if (formTitle) {
      temp.review_title = formTitle;
    }
    if (formContext) {
      temp.context = formTitle;
    }
    if (formProject) {
      temp.project_id = formProject;
    }
    if (formCity) {
      temp.city = formCity;
    }
    if (formLayer) {
      temp.layer_id = formLayer;
    }
    if (formTask) {
      temp.task_id = formTask;
    }

    formData.append("username", userData?.user?.username);
    formData.append("params", JSON.stringify(temp));
    setIsProgress(true);
    serviceGetComment(formData)
      .then((res) => {
        setIsProgress(false);
        if (res.data.status == "success") {
          setQueryTable(res.data.reviews);
          setFilterTable(res.data.reviews);
          if (res.data.reviews.length == 0) {
            showToast("No reviews.", Type.NOTIFICATION.WARNING);
          }
        }
      })
      .catch((err) => {
        setIsProgress(false);
        console.error("Error", err);
      });
  };

  const filter = () => {
    const lowerSearch = searchText.toLowerCase();

    let filtered = queryTable.filter((item) =>
      Object.values(item).some((value) => {
        if (typeof value === "string" && value) {
          return value.toLowerCase().includes(lowerSearch);
        }
        return false;
      }),
    );
    setFilterTable(filtered);
  };

  const reset = () => {
    setQueryTable([]);
    setFilterTable([]);
  };

  const showBboxOnMap = (item) => {
    showBBoxOnMap(viewerRef.current, item.bbox);
  };

  useEffect(() => {
    if (projects) {
      let temp = [];
      for (const key in projects) {
        temp.push({ label: projects[key].project_name, value: projects[key].id });
      }
      setProjectOptions(
        createListCollection({
          items: temp,
        }),
      );
    }
  }, [projects]);

  useEffect(() => {
    if (city) {
      let temp = [];
      for (const key in city) {
        temp.push({ label: city[key].name, value: city[key].name.toLowerCase() });
      }
      setCityOptions(
        createListCollection({
          items: temp,
          itemToString: (item) => item.label,
          itemToValue: (item) => item.value,
        }),
      );
    }
  }, [city]);

  const updateTaskOptions = (projectId) => {
    let serviceData = {};

    let temp = {
      project_id: projectId,
    };
    serviceData.params = JSON.stringify(temp);

    serviceGetTask(serviceData, userData.token)
      .then((res) => {
        if (res.data.status === "success") {
          let temp = [];
          for (const key in res.data.tasks) {
            temp.push({ label: res.data.tasks[key].title, value: res.data.tasks[key].id });
          }
          setTaskOptions(
            createListCollection({
              items: temp,
            }),
          );
        }
      })
      .catch((err) => {
        console.error("Error", err);
        showToast(err, Type.NOTIFICATION.ERROR);
      });
  };

  const [reviewLoading, setReviewLoading] = useState({});

  const handleReviewStatus = async (review, status) => {
    const key = `${review.id}_${status}`; // unique key per button
    setReviewLoading((p) => ({ ...p, [key]: true }));

    const temp = {
      review_id: review.id,
      status,
    };

    try {
      const res = await serviceComment({ data: JSON.stringify(temp) });

      if (res.data.status === "success") {
        showToast(res.data.message, Type.NOTIFICATION.SUCCESS);
      } else {
        showToast(res.data.message, Type.NOTIFICATION.WARNING);
      }
    } catch (err) {
      console.error("Error", err);
      showToast(err.message, Type.NOTIFICATION.ERROR);
    } finally {
      setReviewLoading((p) => ({ ...p, [key]: false }));
    }
  };

  return (
    <Dialog.Root
      scrollBehavior="inside"
      placement={"top"}
      motionPreset="slide-in-right"
      closeOnInteractOutside={false}
      modal={false}
      open={isShowCommentReviewDialog}
      onOpenChange={(e) => {
        setIsShowCommentReviewDialog(e.open);
      }}
    >
      <Portal>
        <Dialog.Positioner pointerEvents="none">
          <Dialog.Content mr={"70px"} mt={"100px"} width={"fit-content"} pointerEvents="all">
            <Dialog.Header>
              <VStack gap={0}>
                <Dialog.Title textAlign={"left"} width={"full"}>
                  Review Comments
                </Dialog.Title>
              </VStack>
            </Dialog.Header>
            <Dialog.Body>
              <SimpleGrid columns={2} gap={2} mb={2} width={"full"}>
                <Field.Root mt={2}>
                  <Box pos="relative" w="full">
                    <Input
                      placeholder="Enter your review ID"
                      value={formReviewId}
                      onChange={(v) => {
                        setFormReviewId(v.target.value);
                      }}
                    />
                    <Field.Label css={floatingStyles}>
                      <LuText /> Review ID
                    </Field.Label>
                  </Box>
                </Field.Root>

                <Field.Root mt={2}>
                  <Box pos="relative" w="full">
                    <Select.Root
                      collection={cityOptions}
                      size="sm"
                      width="full"
                      onValueChange={(v) => {
                        setFormCity(v.value[0]);
                      }}
                    >
                      <Select.HiddenSelect />

                      <Select.Control>
                        <Select.Trigger>
                          <Select.ValueText placeholder={"City"} />
                        </Select.Trigger>
                        <Select.IndicatorGroup>
                          <Select.ClearTrigger />
                          <Select.Indicator />
                        </Select.IndicatorGroup>
                      </Select.Control>

                      <Select.Positioner>
                        <Select.Content>
                          {cityOptions.items.map((item) => (
                            <Select.Item item={item} key={item.value}>
                              {item.label}
                              <Select.ItemIndicator />
                            </Select.Item>
                          ))}
                        </Select.Content>
                      </Select.Positioner>
                    </Select.Root>
                    <Field.Label css={floatingStyles}>
                      <LuTowerControl /> City
                    </Field.Label>
                  </Box>
                </Field.Root>

                <Field.Root mt={2}>
                  <Box pos="relative" w="full">
                    <Select.Root
                      collection={titleOptions}
                      size="sm"
                      width="full"
                      onValueChange={(v) => {
                        setFormTitle(v.value[0]);
                      }}
                    >
                      <Select.HiddenSelect />

                      <Select.Control>
                        <Select.Trigger>
                          <Select.ValueText placeholder={formTitle ? formTitle : "Select Title"} />
                        </Select.Trigger>
                        <Select.IndicatorGroup>
                          <Select.ClearTrigger />
                          <Select.Indicator />
                        </Select.IndicatorGroup>
                      </Select.Control>

                      <Select.Positioner>
                        <Select.Content>
                          <ReviewTitleOptions collection={titleOptions} />
                        </Select.Content>
                      </Select.Positioner>
                    </Select.Root>
                    <Field.Label css={floatingStyles}>
                      <LuText /> Title
                    </Field.Label>
                  </Box>
                </Field.Root>

                {userType.includes(Type.ROLE.SUPER_ADMIN) && (
                  <Field.Root mt={2}>
                    <Box pos="relative" w="full">
                      <Input
                        placeholder="Enter your user"
                        value={formUser}
                        onChange={(v) => {
                          setFormUser(v.target.value);
                        }}
                      />
                      <Field.Label css={floatingStyles}>
                        <LuUser /> User
                      </Field.Label>
                    </Box>
                  </Field.Root>
                )}

                <Field.Root mt={2}>
                  <Box pos="relative" w="full">
                    <Select.Root
                      collection={projectOptions}
                      size="sm"
                      width="full"
                      defaultValue={[formProject]}
                      onValueChange={(v) => {
                        setFormProject(v.value[0]);

                        for (const key in projects) {
                          if (projects[key].id == v.value[0]) {
                            let temp = [{ label: "No Layer", value: "" }];
                            for (const key2 in projects[key].layers) {
                              temp.push({ label: projects[key].layers[key2].layer_name, value: projects[key].layers[key2].id });
                            }
                            setLayerOptions(
                              createListCollection({
                                items: temp,
                              }),
                            );
                            break;
                          }
                        }

                        updateTaskOptions(v.value[0]);
                      }}
                    >
                      <Select.HiddenSelect />

                      <Select.Control>
                        <Select.Trigger>
                          <Select.ValueText placeholder={"Project"} />
                        </Select.Trigger>
                        <Select.IndicatorGroup>
                          <Select.ClearTrigger />
                          <Select.Indicator />
                        </Select.IndicatorGroup>
                      </Select.Control>

                      <Select.Positioner>
                        <Select.Content>
                          {projectOptions.items.map((item) => (
                            <Select.Item item={item} key={item.value}>
                              {item.label}
                              <Select.ItemIndicator />
                            </Select.Item>
                          ))}
                        </Select.Content>
                      </Select.Positioner>
                    </Select.Root>
                    <Field.Label css={floatingStyles}>
                      <LuFolder /> Project
                    </Field.Label>
                  </Box>
                </Field.Root>
                <Field.Root mt={2}>
                  <Box pos="relative" w="full">
                    <Select.Root
                      collection={layerOptions}
                      size="sm"
                      width="full"
                      onValueChange={(v) => {
                        setFormLayer(v.value[0]);
                      }}
                    >
                      <Select.HiddenSelect />

                      <Select.Control>
                        <Select.Trigger>
                          <Select.ValueText placeholder={"Layer"} />
                        </Select.Trigger>
                        <Select.IndicatorGroup>
                          <Select.ClearTrigger />
                          <Select.Indicator />
                        </Select.IndicatorGroup>
                      </Select.Control>

                      <Select.Positioner>
                        <Select.Content>
                          {layerOptions.items.map((item) => (
                            <Select.Item item={item} key={item.value}>
                              {item.label}
                              <Select.ItemIndicator />
                            </Select.Item>
                          ))}
                        </Select.Content>
                      </Select.Positioner>
                    </Select.Root>
                    <Field.Label css={floatingStyles}>
                      <LuLayers /> Layer
                    </Field.Label>
                  </Box>
                </Field.Root>
                <Field.Root mt={2}>
                  <Box pos="relative" w="full">
                    <Select.Root
                      collection={taskOptions}
                      size="sm"
                      width="full"
                      onValueChange={(v) => {
                        setFormTask(v.value[0]);
                      }}
                    >
                      <Select.HiddenSelect />

                      <Select.Control>
                        <Select.Trigger>
                          <Select.ValueText placeholder={"Task"} />
                        </Select.Trigger>
                        <Select.IndicatorGroup>
                          <Select.ClearTrigger />
                          <Select.Indicator />
                        </Select.IndicatorGroup>
                      </Select.Control>

                      <Select.Positioner>
                        <Select.Content>
                          {taskOptions.items.map((item) => (
                            <Select.Item item={item} key={item.value}>
                              {item.label}
                              <Select.ItemIndicator />
                            </Select.Item>
                          ))}
                        </Select.Content>
                      </Select.Positioner>
                    </Select.Root>
                    <Field.Label css={floatingStyles}>
                      <LuLayers /> Task
                    </Field.Label>
                  </Box>
                </Field.Root>
              </SimpleGrid>
              <Field.Root mt={3}>
                <Box pos="relative" w="full">
                  <Textarea
                    className="peer"
                    placeholder=""
                    type="text"
                    rows={2}
                    value={formContext}
                    onChange={(v) => {
                      setFormContext(v.target.value);
                    }}
                  />
                  <Field.Label css={floatingStyles}>
                    <LuText /> Context
                  </Field.Label>
                </Box>
              </Field.Root>
              <Button mt={2} onClick={loadComments}>
                {isProgress ? <Spinner size={"sm"} /> : "Load"}
              </Button>
              <Button mt={2} colorPalette={"red"} onClick={reset} ml={2}>
                Reset
              </Button>

              <Separator my={3} />
              {filterTable.length != 0 && (
                <Group attached width={"full"}>
                  <Input
                    flex="1"
                    placeholder="Search ..."
                    value={searchText}
                    onChange={(v) => {
                      setSearchText(v.target.value);
                    }}
                  />
                  <Button bg="black" color={"white"} variant="outline" onClick={filter}>
                    Filter
                  </Button>
                </Group>
              )}

              {filterTable.map((item, index) => (
                <Collapsible.Root key={index} padding="2" borderWidth="1px" mt={2} cursor={"pointer"}>
                  <Collapsible.Trigger paddingY="3" cursor={"pointer"}>
                    <Text textAlign={"left"}>Title: {item.title ? item.title : "Empty"}</Text>
                    <Text textAlign={"left"}>Description: {truncateWords(item.context, 10)}</Text>
                  </Collapsible.Trigger>
                  <Collapsible.Content>
                    <Box padding="4" borderWidth="1px" position={"relative"}>
                      <Button
                        onClick={() => {
                          showBboxOnMap(item);
                        }}
                        bg={"transparent"}
                        color={"MenuText"}
                        position={"absolute"}
                        top={0}
                        right={0}
                      >
                        <LuFocus color={"MenuText"} />
                      </Button>
                      <Button
                        bg="transparent"
                        alignSelf="start"
                        position={"absolute"}
                        top={"30px"}
                        right={0}
                        onClick={() => handleReviewStatus(item, "resolved")}
                        isDisabled={!!reviewLoading[`${item.id}_resolved`]}
                      >
                        <Tooltip content="Resolved">{reviewLoading[`${item.id}_resolved`] ? <Spinner size="xs" color="green" /> : <LuSquareCheck color="green" />}</Tooltip>
                      </Button>
                      <Button
                        bg="transparent"
                        alignSelf="start"
                        position={"absolute"}
                        top={"60px"}
                        right={0}
                        onClick={() => handleReviewStatus(item, "assigned_to_admin")}
                        isDisabled={!!reviewLoading[`${item.id}_assigned_to_admin`]}
                      >
                        <Tooltip content="Assigned To Admin">{reviewLoading[`${item.id}_assigned_to_admin`] ? <Spinner size="xs" color="MenuText" /> : <LuShieldQuestion color="MenuText" />}</Tooltip>
                      </Button>

                      <HStack gap={2}>
                        <LuText />
                        <Text>Title: {item.title ? item.title : "Empty"}</Text>
                      </HStack>
                      <HStack gap={2}>
                        <LuUser />
                        <Text>Username: {item.username}</Text>
                      </HStack>
                      <HStack gap={2}>
                        <LuLayers />
                        <Text> Layer Name: {item.layer_name ? item.layer_name : "Empty"}</Text>
                      </HStack>
                      <HStack gap={2}>
                        <LuFolder />
                        <Text> Project Name: {item.project ? item.project.project_name : "Empty"}</Text>
                      </HStack>
                      <HStack gap={2}>
                        <LuLayers />
                        <Text>Feature ID: {item.feature_id ? item.feature_id : "Empty"}</Text>
                      </HStack>
                      <HStack gap={2}>
                        <LuTowerControl />
                        <Text>City: {item.city ? item.city : "Empty"}</Text>
                      </HStack>
                      <HStack gap={2}>
                        <LuClock />
                        <Text>Time: {item.timestamp}</Text>
                      </HStack>
                      <HStack gap={2} mt={2}>
                        <Text>Description: {item.context ? item.context : "Empty"}</Text>
                      </HStack>
                    </Box>
                  </Collapsible.Content>
                </Collapsible.Root>
              ))}
            </Dialog.Body>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default CommentReviewDialog;
